import { render, staticRenderFns } from "./soilCount.vue?vue&type=template&id=4ad1e194&scoped=true&"
import script from "./soilCount.vue?vue&type=script&lang=js&"
export * from "./soilCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad1e194",
  null
  
)

export default component.exports